import { css } from 'styled-components';
import {
  BreakpointQueryName, getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
  onClick,
}) => css`
  border: 1px solid ${theme.palettes.neutrals.light};
  ${getSpacing.padding(theme, [SpacingName.SMALL])};
  background-color: ${theme.palettes.neutrals.lightest};
  height: 100%;
  display: flex;
  text-align: left;
  justify-content: space-between;
  gap: 0.75rem;
  border-radius: 0.5rem;

  ${onClick && `
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);

    &:hover {
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
    }
  `}
`;

export const image: ThemedFunctor = ({ theme }) => css`
  flex-shrink: 0;
  width: 3rem;

  img {
    width: 100%;
    display: block;
  }

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    width: 4rem;
  }
`;

export const info: ThemedFunctor = () => css`
  flex-grow: 1;
  display: flex;
  align-items: center;
`;
